import React, { Component } from 'react';
import Login from './Login'
import {browserHistory} from "react-router";


class Home extends Component {
    componentDidMount(){
        var user = localStorage.getItem('user');
        if(user){
            browserHistory.push("/token-list");
        }
    }
    render() 
    {
        return(
            <div>
                <Login/>
            </div>
        )

    }
}

export default Home;